import Vue from "vue";
import VueRouter from "vue-router";
// 路由懒加载
const Login = () => import("../views/Login.vue");
const Register = () => import("../views/Register.vue");
const ForgetPwd = () => import("../views/ForgetPwd.vue");
const RegInstructions = () => import("../views/RegInstructions.vue");
const Advertising = () => import("../views/Advertising.vue");
const UseClauses = () => import("../views/UseClauses.vue");
const Home = () => import("../views/Home.vue");
const Search = () => import("../views/Search.vue");
const CommonIndex = () => import("../views/CommonIndex.vue");
const bannerDetails = () => import("../views/bannerDetails.vue");
const More = () => import("../views/More.vue");
const EquipmentDetails = () => import("../views/EquipmentDetails.vue");
const My = () => import("../views/my/Index.vue");
const PersonalInfo = () => import("../views/my/PersonalInfo.vue");
const MyMessage = () => import("../views/my/MyMessage.vue");
const TrainingTest = () => import("../views/my/TrainingTest.vue");
const TestCenter = () => import("../views/my/TestCenter.vue");
const Favorites = () => import("../views/my/Favorites.vue");
const BrowserHistory = () => import("../views/my/BrowserHistory.vue");
const TrainingDetail = () => import("../views/my/TrainingDetail.vue");
const TestHistory = () => import("../views/my/TestHistory.vue");
const TestDetail = () => import("../views/my/TestDetail.vue");
const FeedBack = () => import("../views/my/FeedBack.vue");
const Certificate = () => import("../views/my/Certificate.vue");
const CertificateDetail = () => import("../views/my/CertificateDetail.vue")
const Examination = () => import("../views/exam/Examination.vue");
const ExamCompleted = () => import("../views/exam/ExamCompleted.vue");
const ExamResult = () => import("../views/exam/ExamResult.vue");
const PreviewArea = () => import("../views/PreviewArea.vue");
const Comps = () => import("../views/IconMenu/Comps.vue");
const AcademicData = () => import("../views/IconMenu/AcademicData.vue");
const DocumentsUpload = () => import("../views/IconMenu/DocumentsUpload.vue");
const ModelsDetails = () => import("../views/IconMenu/ModelsDetails.vue");
const Science = () => import("../views/science/Science.vue");
const Tools = () => import("../views/other/Tools.vue");
const TestList = () => import("../views/IconMenu/TestList.vue");
const PreviewAreaSearch = () => import("../views/PreviewAreaSearch.vue");
Vue.use(VueRouter);

const routes = [
  { path: "/", redirect: "/index" },
  { path: "/login", component: Login },
  { path: "/register", component: Register },
  { path: "/forgetPwd", component: ForgetPwd },
  { path: "/regInstructions", component: RegInstructions },
  { path: "/advertising", component: Advertising },
  { path: "/useClauses", component: UseClauses },
  { path: "/index", component: Home },
  { path: "/search", component: Search },
  {
    path: "/commonIndex",
    component: CommonIndex,
    children: [
      { path: "/bannerDetails", component: bannerDetails },
      { path: "/more", component: More },
      { path: "/equipmentDetails", component: EquipmentDetails },
      { path: "/Comps", component: Comps },
      { path: "/academicData", component: AcademicData },
      { path: "/documentsUpload", component: DocumentsUpload },
      { path: "/modelsDetails", component: ModelsDetails },
      { path: "/testList", component: TestList },
      {
        path: "/my",
        component: My,
        children: [
          { path: "/my/personalInfo", component: PersonalInfo },
          { path: "/my/myMessage", component: MyMessage },
          { path: "/my/trainingTest", component: TrainingTest },
          { path: "/my/testCenter", component: TestCenter },
          { path: "/my/favorites", component: Favorites },
          { path: "/my/browserHistory", component: BrowserHistory },
          { path: "/my/trainingTest/testHistory", component: TestHistory },
          { path: "/my/feedBack", component:FeedBack },
          { path: "/my/certificate", component:Certificate },
          { path: "/my/certificateDetail", component:CertificateDetail },
        ]
      },
      { path: "/trainingDetail", component: TrainingDetail },
      { path: "/testDetail", component: TestDetail },
      { path: "/examination", component: Examination },
      { path: "/examCompleted", component: ExamCompleted },
      { path: "/examResult", component: ExamResult },
      { path: "/previewArea", component: PreviewArea },
      { path: "/previewAreaSearch", component: PreviewAreaSearch },
      { path: "/science", component: Science },
      { path: "/tools", component: Tools }

    ]
  }
];

const router = new VueRouter({
  routes
});

// 挂载路由导航守卫,to表示将要访问的路径，from表示从哪里来，next是下一个要做的操作 next('/login')强制跳转login
router.beforeEach((to, from, next) => {
  // 访问登录页，放行
  if (to.path === '/index' || to.path === '/login' || to.path === '/register' || to.path === '/forgetPwd' || to.path === '/regInstructions'|| to.path === '/advertising'|| to.path === '/useClauses' || to.path === '/bannerDetails') return next();
  // 获取token
  var member = JSON.parse(localStorage.getItem('member'))
  if(member != null){
    const isLogin =  JSON.parse(localStorage.getItem('member')).isLogin;
    // 没有token, 强制跳转到登录页isLogin
    if (typeof undefined === isLogin || null === isLogin || "" === isLogin) return next('/login')
    next()
  }else{
    return next('/login')
  }
})
export default router;
